<template>
  <div class="checkout-section payment-page" :class="[ paymentMethod ]">
    <div class="container pd-sm-0" v-if="!$utils.isCartEmpty()">
      <payment-summary class="show-sm" v-if="false"></payment-summary>

      <div class="with-sidebar">
        <div class="content">
          <div class="sidebar block-border block shadow radius show-sm">
            <div class="summary__row--lg" v-for="cart in $store.state.cart">
              <div class="title mb-15">{{ $store.state.donateType === 'monthly' ? 'บริจาครายเดือนให้กับ' : 'บริจาคให้กับ' }}</div>
              <div class="summary__label">{{ cart.attributes.page.title }}</div>
              <div class="summary__value">{{ cart.product.price | comma }} <span class="txt-normal">บาท</span></div>
            </div>
          </div>

          <div class="block-primary block shadow radius b-email">
            <h2 class="block__title">ข้อมูลยืนยันการบริจาค</h2>

            <div class="row">
              <div class="col-md-6">
                <div class="form__item--block">
                  <label class="form__label" for="email">อีเมล</label>
                  <input class="form__text" type="text" name="email" id="email" placeholder="กรอกอีเมลเพื่อรับใบเสร็จรับเงิน" v-model="email" required :class="{ 'form__input--error': $v.isError('email') }" />
                  <div class="alert alert--error" v-show="$v.$errors.email.empty">กรุณากรอกอีเมล</div>
                  <div class="alert alert--error" v-show="$v.$errors.email.invalid">กรุณากรอกอีเมลให้ถูกต้อง</div>
                  <div class="alert alert--error" v-show="$v.$errors.email.facebookEmail">กรุณากรอกอีเมลที่ใช้ได้จริง ไม่อนุญาตให้ใช้อีเมลของ Facebook</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form__item--block">
                  <label class="form__label" for="phone">เบอร์ติดต่อ</label>
                  <input class="form__text" type="text" name="phone" id="phone" placeholder="กรอกเบอร์โทรศัพท์สำหรับติดต่อ" v-model="phone" required pattern="[0-9+-]*" :class="{ 'form__input--error': $v.isError('phone') }" />
                  <div class="alert alert--error" v-show="$v.$errors.phone.empty">กรุณากรอกเบอร์ติดต่อ</div>
                  <div class="alert alert--error" v-show="!$v.$errors.phone.empty && $v.$errors.phone.invalid">กรุณากรอกเบอร์ติดต่อให้ถูกต้อง</div>
                </div>
              </div>
            </div>

            <div class="b-receipt mt-15">
              <h2 class="block__title ma-0">ใบเสร็จเพื่อลดหย่อนภาษี</h2>
               <div class="fs-sm mb-15">
                  ระบบจะจัดส่งสำเนาใบเสร็จเป็นไฟล์ PDF ไปยังอีเมลของคุณ หลังจากการบริจาคสำเร็จแล้ว <br />
                  <span>(กรุณาตรวจสอบข้อมูลให้ถูกต้อง)</span>

                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form__item--block">
                      <label class="form__label" for="fullname">ชื่อ-นามสกุล (โปรดระบุคำนำหน้า)</label>
                      <input class="form__text" type="text" name="fullname" id="fullname" placeholder="ชื่อ-นามสกุล (โปรดระบุคำนำหน้า)"v-model="receiptFullname" :class="{ 'form__input--error': $v.isError('receiptFullname') }" />
                      <div class="alert alert--error" v-show="$v.$errors.receiptFullname.empty">กรุณากรอกข้อมูล</div>
                      <div class="fs-xs mb-10">ตัวอย่าง นางสาวสมศรี สุขสมหวัง </div>
                      <div class="fs-xs">กรุณากรอกด้วยชื่อ-นามสกุลจริงตามบัตรประชาชนเพื่อสิทธิประโยชน์ในการลดหย่อนภาษี</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form__item--block">
                      <label class="form__label" for="taxid">เลขประจำตัวเสียผู้ภาษี หรือเลขประจำตัวประชาชน</label>
                      <input class="form__text" type="text" name="taxid" id="taxid" v-model="taxId" placeholder="กรอกหมายเลขประจำตัวผู้เสียภาษี 13 หลัก" :class="{ 'form__input--error': $v.isError('taxId') }" maxlength="17" v-mask="'#-####-#####-##-#'" />
                      <div class="alert alert--error" v-show="$v.$errors.taxId.empty">กรุณากรอกข้อมูล</div>
                      <div class="fs-xs" v-show="!$v.$errors.taxId.empty && $v.$errors.taxId.invalid">กรุณากรอกด้วยเลขประจำตัวผู้เสียภาษีเพื่อสิทธิประโยชน์ในการลดหย่อนภาษี</div>
                      <div class="alert alert--error" v-show="!$v.$errors.taxId.empty && $v.$errors.taxId.taxIdFormatInvalid">รูปแบบบัตรประชาชนไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง</div>
                    </div>
                  </div>
                </div>

                <div class="form__item--block mb-15 mt-15 hide">
                  <input class="form__input" type="checkbox" name="need_receipt" id="need_receipt" v-model="needReceiptShipping" />
                  <label class="form__label" for="need_receipt">ต้องการใบเสร็จลดหย่อนภาษีตัวจริงทางไปรษณีย์</label>
                </div>

                <div v-if="needReceiptShipping" class="receipt-shipping-info hide">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form__item--block">
                        <label class="form__label" for="address">ที่อยู่</label>
                        <textarea class="form__textarea" rows="3" name="address" id="address" v-model="receiptAddress" :class="{ 'form__input--error': $v.isError('receiptAddress') }"></textarea>
                        <div class="alert alert--error" v-show="$v.$errors.receiptAddress.empty">กรุณากรอกที่อยู่</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form__item--block">
                        <label class="form__label" for="province">จังหวัด</label>
                        <div class="form__select">
                          <select class="" name="province" id="province" v-model="receiptProvince" :class="{ 'form__input--error': $v.isError('receiptProvince') }">
                            <option :value="pItem.code" :key="pItem.code" v-for="pItem in $utils.getProvinces()">{{ pItem.name }}</option>
                          </select>
                        </div>
                        <div class="alert alert--error" v-show="$v.$errors.receiptProvince.invalid">กรุณาเลือกจังหวัด</div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form__item--block">
                        <label class="form__label" for="zipcode">รหัสไปรษณีย์</label>
                        <input class="form__text" type="text" name="zipcode" id="zipcode" v-model="receiptPostalCode" pattern="[0-9]{5}"
                              :class="{ 'form__input--error': $v.isError('receiptPostalCode') }" max-length="5" />
                        <div class="alert alert--error" v-show="$v.$errors.receiptPostalCode.empty">กรุณากรอกรหัสไปรษณีย์</div>
                        <div class="alert alert--error" v-show="$v.$errors.receiptPostalCode.invalid">กรุณากรอกรหัสไปรษณีย์ให้ถูกต้อง</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <div class="block-primary block shadow radius b-delivery" v-if="isShippingRequired">
            <h2 class="block__title ma-0">ที่อยู่สำหรับจัดส่งของ</h2>
            <div class="fs-sm mb-15"> </div>

            <div class="receipt-shipping-info ">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form__item--block">
                      <label class="form__label" for="fullname">ชื่อผู้รับ</label>
                      <input class="form__text" type="text" name="fullname" v-model="fullname" :class="{ 'form__input--error': $v.isError('fullname') }" />
                      <div class="alert alert--error" v-show="$v.$errors.fullname.empty">กรุณากรอกข้อมูล</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form__item--block">
                      <label class="form__label" for="address">ที่อยู่ (ระบุบ้านเลขที่ หมู่ที่ ถนน แขวง/ตำบล เขต/อำเภอ )</label>
                      <textarea class="form__textarea" rows="3" name="address" v-model="shippingAddress" :class="{ 'form__input--error': $v.isError('shippingAddress') }"></textarea>
                      <div class="alert alert--error" v-show="$v.$errors.shippingAddress.empty">กรุณากรอกที่อยู่</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form__item--block">
                      <label class="form__label" for="province">จังหวัด</label>
                      <div class="form__select">
                        <select class="" name="province" v-model="shippingProvince" :class="{ 'form__input--error': $v.isError('shippingProvince') }">
                          <option :value="pItem.code" :key="pItem.code" v-for="pItem in $utils.getProvinces()">{{ pItem.name }}</option>
                        </select>
                      </div>
                      <div class="alert alert--error" v-show="$v.$errors.shippingProvince.empty">กรุณาเลือกจังหวัด</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form__item--block">
                      <label class="form__label" for="zipcode">รหัสไปรษณีย์</label>
                      <input class="form__text" type="text" name="zipcode" v-model="shippingPostCode" pattern="[0-9]{5}"
                            :class="{ 'form__input--error': $v.isError('shippingPostCode') }" max-length="5" />
                      <div class="alert alert--error" v-show="$v.$errors.shippingPostCode.empty">กรุณากรอกรหัสไปรษณีย์</div>
                      <div class="alert alert--error" v-show="$v.$errors.shippingPostCode.invalid">กรุณากรอกรหัสไปรษณีย์ให้ถูกต้อง</div>
                    </div>
                  </div>
                </div>
              </div>
          </div>

          <div class="block-primary block shadow radius b-payment">
            <form class="form" @submit.prevent="submit()" novalidate>
              <h2 class="block__title">ช่องทางการบริจาค</h2>
              <!-- <p class="text-muted-ss">ข้อมูลเกี่ยวกับการชำระเงินจะถูกเก็บรักษาภายใต้ความปลอดภัยของระบบ</p> -->

              <div class="alert alert--error" v-show="$v.$errors.paymentMethod.empty">กรุณาเลือกวิธีการบริจาค</div>

              <div class="form__wrapper">

                <!-- CREDIT CARD -->
                <div class="form__section" v-if="isPaymentMethodEnable('credit_card')">
                  <div class="form__item form__item--inline" @click="paymentMethod = 'credit_card'">
                    <input class="form__input" type="radio" id="creditcard" v-model="paymentMethod" name="payment_method" value="credit_card" />
                    <label class="form__label form__label--title" for="creditcard">Credit card</label>
                    <div class="block--icon-bank">
                      <img :src="$utils.svg(require('../assets/img/ic-visa.svg'))" alt="Visa" height="18" />
                      <img :src="$utils.svg(require('../assets/img/ic-mastercard.svg'))" alt="Master Card" height="20" />
                      <img :src="$utils.svg(require('../assets/img/ic-jcb.svg'))" alt="JCB" height="18" />
                    </div>
                  </div>
                </div><!-- end form section -->
                <transition name="slide-down" v-if="isPaymentMethodEnable('credit_card')">
                  <div class="slide-down-wrapper" v-show="isCreditCard">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--inline">
                        <div class="text-left">
                          <p class="text-muted-ss">ข้อมูลบัตรจะถูกดำเนินการอย่างปลอดภัยด้วยผู้ให้บริการที่ผ่านมาตรฐาน</p>
                          <img src="../assets/img/2C2P-PDI-DSS.png" alt="2C2P PCI CSS" width="80px" />
                          <img src="../assets/img/2C2P-PCI-PA-DSS.png" alt="2C2P PCI PA DSS" width="80px" class="mx-20"  />
                          <img src="../assets/img/2c2p-logo.png" alt="2C2P" width="80px"  />
                        </div>

                      </div>
                    </div> <!-- end form_section -->
                  </div>
                </transition>
                <transition name="slide-down" v-if="false">
                  <div class="slide-down-wrapper" v-show="isCreditCard">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item">
                        <label class="form__label" for="id-creditcard">หมายเลขบัตร 16 หลัก</label>
                        <input class="form__input" type="text" name="id-creditcard" id="id-creditcard"
                               v-model="ccNumber" :required="useCreditCard"
                               v-on:keydown="validateCreditCardKey"
                               v-on:input="updateCreditCardValue"
                               autocomplete="new-password"
                               :readonly="!formReady"
                               :class="{ 'form__input--error': $v.isError('ccNumber') }" />

                        <div class="alert alert--error" v-show="$v.$errors.ccNumber.empty">กรุณากรอกหมายเลขบัตร</div>
                        <div class="alert alert--error" v-show="$v.$errors.ccNumber.invalid">กรุณากรอกหมายเลขบัตรให้ถูกต้อง</div>
                        <i class="lock__icon icon-lock"></i>
                      </div>
                      <div class="form__item">
                        <label class="form__label" for="name-creditcard">ชื่อผู้ถือบัตร</label>
                        <input class="form__input" type="text" value="" name="name-creditcard" id="name-creditcard"
                               v-model="ccHolderName"
                               v-on:keydown="validateCreditCardHolderKey"
                               v-on:input="updateCreditCardHolder"
                               :required="useCreditCard"
                               :readonly="!formReady"
                               :class="{ 'form__input--error': $v.isError('ccHolderName') }" />
                        <div class="alert alert--error" v-show="$v.$errors.ccHolderName.empty">กรุณากรอกชื่อผู้ถือบัตร</div>
                      </div>
                      <div class="form__item">
                        <label class="form__label" for="expired">MM/YY</label>
                        <input class="form__input" type="text" value="" name="expired" id="expired"
                               v-model="ccExpired" :required="useCreditCard" pattern="[0-9]{2}/[0-9]{2}"
                               :readonly="!formReady"
                               v-on:keydown="validateExpiredKey"
                               v-on:input="updateExpiredValue($event.target.value)"
                               :class="{ 'form__input--error': $v.isError('ccExpired') }" />
                        <div class="alert alert--error" v-show="$v.$errors.ccExpired.empty">กรุณากรอกเดือน/ปีที่หมดอายุ</div>
                        <div class="alert alert--error" v-show="$v.$errors.ccExpired.invalid">กรุณากรอกเดือน/ปีให้ถูกต้อง</div>
                      </div>
                      <div class="form__item--securitycode w-30">
                        <div class="form__item">
                          <label class="form__label" for="cvv">CVV</label>
                          <input class="form__input" type="password" value="" name="cvv" id="cvv"
                                 v-model="ccCVV" :required="useCreditCard"
                                 v-on:keydown="validateCVVKey"
                                 autocomplete="new-password"
                                 :readonly="!formReady"
                                 :class="{ 'form__input--error': $v.isError('ccCVV') }" />
                          <div class="alert alert--error" v-show="$v.$errors.ccCVV.empty">กรุณากรอกรหัสหลังบัตร 3 หลัก</div>
                          <div class="alert alert--error" v-show="$v.$errors.ccCVV.invalid">กรุณากรอกรหัสหลังบัตรให้ถูกต้อง</div>
                        </div>
                        <a class="tooltips"><i class="icon-help"><span class="data">รหัสความปลอดภัยหลังบัตร 3 หลัก</span></i></a>
                      </div>

                      <div class="mt-15 text-center">
                        <p class="text-muted-ss">ข้อมูลบัตรจะถูกดำเนินการอย่างปลอดภัยด้วยผู้ให้บริการที่ผ่านมาตรฐาน</p>
                        <img class="block__img" src="../assets/img/ic-omise.png" alt="omise"  />
                      </div>

                    </div> <!-- end form_section -->
                  </div>
                </transition>

                <!-- LINE PAY -->
                <div class="form__section" @click="paymentMethod = 'line_pay'" v-if="isPaymentMethodEnable('line_pay')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="line_pay" v-model="paymentMethod" value="line_pay" />
                    <label class="form__label form__label--title" for="line_pay">Rabbit LINE Pay</label>
                    <div class="block--icon-bank">
                      <img src="/static/img/icons/ic-line_pay.png" srcset="/static/img/icons/ic-line_pay.png 1x, /static/img/icons/ic-line_pay@2x.png 2x" alt="Rabbit LINE Pay" height="22" />
                    </div>
                  </div>
                </div>
                <transition name="slide-down" v-if="isPaymentMethodEnable('line_pay')">
                  <div class="slide-down-wrapper" v-show="isLinePay">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--inline">
                        <div>
                          <ul class="text-muted-ss">
                            <li>สามารถชำระเงินด้วยบัตรเดบิต / เครดิต หรือช่องทางอื่นๆ ของ Rabbit LINE Pay ได้ </li>
                            <li>Rabbit LINE Pay พร้อมให้บริการใน LINE App ตั้งแต่เวอร์ชั่น 4.8.0 ใน iPhone และ ตั้งแต่เวอร์ชั่น 5.4.1 ใน Android</li>
                          </ul>

                        </div>
                      </div>
                    </div> <!-- end form_section -->
                  </div>
                </transition>

                <!-- INTERNET BANKING -->
                <div class="form__section" @click="paymentMethod = 'internet_banking'" v-if="isPaymentMethodEnable('internet_banking')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="internet_banking" v-model="paymentMethod" value="internet_banking" />
                    <label class="form__label form__label--title" for="internet_banking">Internet Banking</label>
                    <span class="block--icon-bank">
                    <img v-for="bank in $config.OMISE_INTERNET_BANKING" :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="30" height="30" :alt="bank[1]"   />
                  </span>
                  </div>
                </div>
                <transition name="slide-down" v-if="isPaymentMethodEnable('internet_banking')">
                  <div class="slide-down-wrapper" v-show="isInternetBanking">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--inline">
                        <div class="alert alert--error" v-show="$v.$errors.internetBankingOffsite.empty">กรุณาเลือกธนาคาร</div>
                        <div class="block__flex block--internet_banking" v-for="bank in $config.OMISE_INTERNET_BANKING">
                          <div class="radio">
                            <input type="radio" name="offsite" v-model="internetBankingOffsite" :id="`offsite_${ bank[0] }`" :value="`internet_banking_${ bank[0] }`" :required="isInternetBanking">
                            <label :for="`offsite_${ bank[0] }`">
                              <img :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="40" :alt="bank[1]"  />
                              <strong>{{ bank[1] }}</strong>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div> <!-- end form_section -->
                  </div>
                </transition>

                <!-- 2C2P 123 -->
                <div class="form__section" @click="paymentMethod = '2c2p:123'" v-if="isPaymentMethodEnable('2c2p:123')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="2c2p_123" v-model="paymentMethod" value="2c2p:123" />
                    <label class="form__label form__label--title" for="internet_banking">Internet banking / Counter / ATM</label>
                    <span class="block--icon-bank">
                      <span v-for="bank in $config.OMISE_INTERNET_BANKING" class="block__img__wrapper">
                        <img :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="30" height="30" :alt="bank[1]"   />
                      </span>
                    </span>
                    <span class="block--icon-bank">
                      <img src="/static/img/icons/tesco-lotus_logo.png" srcset="/static/img/icons/tesco-lotus_logo.png 1x, /static/img/icons/tesco-lotus_logo@2x.png 2x" alt="Tesco Lotus" height="22" />
                      <img src="/static/img/icons/big-c_logo.png" srcset="/static/img/icons/big-c_logo.png 1x, /static/img/icons/big-c_logo@2x.png 2x" alt="Big C" height="22" />
                      <img src="/static/img/icons/paypost_logo1.png" srcset="/static/img/icons/paypost_logo1.png 1x, /static/img/icons/paypost_logo1@2x.png 2x" alt="PayPost" height="22" />
                      <img src="/static/img/icons/mpay-station_logo.png" srcset="/static/img/icons/mpay-station_logo.png 1x, /static/img/icons/mpay-station_logo@2x.png 2x" alt="M Pay" height="22" />
                      <img src="/static/img/icons/tw_logo.png" srcset="/static/img/icons/tw_logo.png 1x, /static/img/icons/tw_logo@2x.png 2x" alt="true money" height="22" />
                      <img src="/static/img/icons/cenpay_logo.png" srcset="/static/img/icons/cenpay_logo.png 1x, /static/img/icons/cenpay_logo@2x.png 2x" alt="Cen Pay" height="22" />
                      <img src="/static/img/icons/boonterm_logo.png" srcset="/static/img/icons/boonterm_logo.png 1x, /static/img/icons/boonterm_logo@2x.png 2x" alt="บุญเติม" height="22" />
                    </span>
                  </div>
                </div>
                <transition name="slide-down" v-if="isPaymentMethodEnable('2c2p:123')">
                  <div class="slide-down-wrapper" v-show="is2C2P123">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--inline">
                        <div>
                          <ul class="text-muted-ss">
                            <li>สามารถชำระเงินผ่านบริการออนไลน์ของธนาคารได้ดังนี้ ธนาคารไทยพาณิชย์, ธนาคารกรุงไทย, ​ธนาคารยูโอบี,​ ธนาคารกรุงศรีอยุธยา,​ ธนาคารกรุงเทพ,  ธนาคารกสิกรไทย และธนาคารทีเอ็มบีธนชาติ</li>
                            <li>สามารถชำระเงินผ่านเคาน์เตอร์ของตัวแทนได้ดังนี้ Tesco Lotus, Big C, Pay@Post, MPAY, TrueMoney, CENPAY และตู้บุญเติม</li>
                            <li>อาจมีค่าบริการ 5-15 บาทต่อครั้ง ขึ้นอยู่กับผู้บริการ</li>
                          </ul>

                        </div>
                      </div>
                    </div> <!-- end form_section -->
                  </div>
                </transition>

                <!-- BANK TRANSFER -->
                <div class="form__section" @click="paymentMethod = 'bank_transfer'" v-if="isPaymentMethodEnable('bank_transfer')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="tranfer" v-model="paymentMethod" value="bank_transfer" />
                    <label class="form__label form__label--title" for="tranfer">โอนเงินผ่านบัญชีธนาคาร</label>
                    <span class="block--icon-bank">
                      <span v-for="bank in $config.BANK_TRANSFER" class="block__img__wrapper">
                        <img v-if="bank[0] == 'promptpay'" src="../assets/img/icon/promptpay.jpg" height="30" :alt="bank[1]"   />
                        <img v-else :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="30" height="30" :alt="bank[1]"   />
                      </span>
                    </span>
                  </div>
                </div>
                <transition name="slide-down" v-if="isPaymentMethodEnable('bank_transfer')">
                  <div class="slide-down-wrapper" v-show="isTransfer">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--inline">
                        <!-- <div class="block--transfer" v-for="bank in $config.BANK_TRANSFER">
                          <div v-if="bank[0] == 'promptpay'" class="block__flex promptpay__wrapper" >
                            <img class="ic-promptpay" src="../assets/img/icon/promptpay.jpg" height="40" :alt="bank[1]"  />
                            <div class="promptpay--detail">{{ bank[1] }} ชื่อบัญชี: {{ bank[2] }}<br />รหัส {{ bank[3] }} (เลขประจำตัวผู้เสียภาษี)</div>
                          </div>
                          <div v-else class="block__flex" >
                            <img :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="40" :alt="bank[1]"  />
                            <div>{{ bank[1] }} ชื่อบัญชี: {{ bank[2] }}<br />เลขบัญชี {{ bank[3] }}</div>
                          </div>
                          
                        </div>  -->
                        <div class="block--transfer">
                          <div class="block__flex" >
                            <img class="block__img block__img--uob" :src="$utils.svg(require('../assets/img/thaibank/uob.svg'))" width="40" alt="bank[1]"  />
                            <div>ธ. ยูโอบี สาขาพาราไดซ์ ปาร์ค<br />ชื่อบัญชี: มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา <br />เลขบัญชี 813-175-093-5</div>
                          </div>
                          <div class="block__flex">
                            <div class="block__img" style="width: 40px;"></div> 
                            <div>
                              <a href="/static/img/qr-uob-ybf.png" title="บันทึกรูปภาพเพื่อชำระเงิน" type="image/png" download="QRCode-UOB">
                                <img src="/static/img/qr-uob-ybf.png" width="200px" alt="QR Donation" style="margin-top: 10px;" />
                              </a>
                              <div class="mb-2 small text-center">คลิกที่รูปภาพเพื่อดาวน์โหลดชำระเงิน</div>
                            </div>
                          </div>
                        </div>
                        <div class="block--transfer">
                          <div class="block__flex" >
                            <img class="block__img block__img--kbank" :src="$utils.svg(require('../assets/img/thaibank/kbank.svg'))" width="40" alt="bank[1]"  />
                            <div>ธ. กสิกรไทย สาขาพาราไดซ์ ปาร์ค<br />ชื่อบัญชี: มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา <br />เลขบัญชี 030-3-79257-0</div>
                          </div>
                        </div>

                       

                        <div class="block__flex">
                          <i class="alert__icon icon-info"></i>
                          <div class="alert__text">เมื่อชำระเงินเรียบร้อยแล้ว สามารถยืนยันการโอนเงินจากแบบฟอร์มในขั้นตอนถัดไป หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</div>
                        </div>
                      </div>
                      <div class="block text-muted pd-15 font-sm">
                        <ul class="ma-0">
                          <li>เตรียมหลักฐานการโอนเงินเป็นรูปภาพหรือรูปถ่าย เช่น รูปถ่ายใบเสร็จการโอนเงินจากตู้ ATM หรือรูปภาพหน้าจอในกรณีที่ทำธุรกรรมออนไลน์</li>
                          <li>โอนภายในเขตกรุงเทพ ฟรีค่าธรรมเนียมการโอน</li>
                        </ul>
                        </div>
                    </div> <!-- end form_section -->
                  </div>
                </transition>

                <!-- CHECK -->
                <div class="form__section" @click="paymentMethod = 'cheque'" v-if="isPaymentMethodEnable('cheque')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="cheque" value="cheque" />
                    <label class="form__label form__label--title" for="cheque">เช็คสั่งจ่าย</label><br />
                    <span class="form__label--note">มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา</span>
                    <span class="block--icon-bank">
                      <img class="" :src="$utils.svg(require('../assets/img/ic-cheque.svg'))" alt="เช็คสั่งจ่าย"  />
                    </span>
                  </div>
                </div>


                <!-- PAYPAL -->
                <div class="form__section" @click="paymentMethod = 'paypal'" v-if="isPaymentMethodEnable('paypal')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="paypal" v-model="paymentMethod" value="paypal" />
                    <label class="form__label form__label--title" for="paypal">PayPal</label>
                    <img class="fl-right" :src="$utils.svg(require('../assets/img/ic-paypal.svg'))" alt="PayPal"  />
                  </div>
                </div>



              </div><!-- end form_wrapper -->

              <div class="block-primary block fixed fixed--bottom show-sm">
                <div class="">
                  <div class="form__item--inline mb-15">
                    <input class="form__text" type="checkbox" name="terms" id="terms1" v-model="acceptPolicy" />
                    <label class="form__label" for="terms1">ฉันได้อ่านและยอมรับ <a :href="$utils.getWpPath('terms')" target="_blank" style="text-decoration: underline; color: #F7941D;">ข้อตกลงและเงื่อนไข</a></label>
                    <!-- <p class="text-muted-ss">ข้อมูลเกี่ยวกับการชำระเงินจะถูกเก็บรักษาภายใต้ความปลอดภัยของระบบ</p> -->
                  </div>
                </div>
                <button class="btn btn--purple ma-0 btn-confirm" v-if="!isPaypal">ยืนยันการบริจาค</button>
                <paypal-button ref="paypalButton1"
                               v-if="isPaypal"
                               v-show="paypalButtonReady"
                               id="paypal-button"
                               :payment="paypalPayment"
                               :onAuthorize="paypalOnAuthorize"
                               :onCancel="paypalOnCancel"
                               v-on:ready="paypalButtonReady = true"></paypal-button>
                <loader v-if="isPaypal" v-show="!paypalButtonReady"></loader>
                <div class="mt-5 text-muted-ss text-center" v-if="isTransfer">หลังจากโอนเงินแล้ว กรุณายืนยันการโอนเงินจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</div>
              </div>

            </form>
          </div>

          <!-- <div class="block block-primary shadow show-sm">
            <div class="summary__row fs-sm">
              <span>หากท่านใดยังไม่ได้รับอีเมลการบริจาคภายใน 30 นาที ขอรบกวนลูกค้าส่งหมายเลขการบริจาคมายังอีเมล <a :href="'mailto:'+$config.WEBSITE_EMAIL">{{ $config.WEBSITE_EMAIL }}</a> นี้ด้วยค่ะ ทางเราจะดำเนินการตรวจสอบข้อมูลและแจ้งผลกลับไป ขอบคุณค่ะ</span>
            </div>
          </div> -->
        </div>

        <div class="sidebar-container hide-sm">
          <div class="sidebar" v-sticky="{top: 10, triggerTop: 70, triggerBottom: 70, bottom: -90}">
            <div class="block block-border radius shadow">
              <div class="summary__row--lg" v-for="cart in $store.state.cart">
                <div class="sidebar__title">{{ $store.state.donateType === 'monthly' ? 'บริจาครายเดือนให้กับ' : 'บริจาคให้กับ' }}</div>
                <div class="summary__label">{{ cart.attributes.page.data.cart_title || cart.attributes.page.title }}</div>
                <div class="summary__value">{{ cart.product.price | comma }} <span class="txt-normal">บาท</span></div>
              </div>
              <div class="summary__row summary__row--lg" v-if="$store.state.cart.length > 1">
                <div class="summary__label"></div>
                <div class="summary__value">{{ $utils.getCartGrandTotalPrice() | comma }} ฿</div>
              </div>
              <div class="pt-15">
                <div class="form__item form__item--inline">
                  <input class="form__input" type="checkbox" name="terms" id="terms2" v-model="acceptPolicy" />
                  <label class="form__label" for="terms2">ฉันได้อ่านและยอมรับ <a :href="$utils.getWpPath('terms')" target="_blank" style="text-decoration: underline; color: #F7941D;">ข้อตกลงและเงื่อนไข</a></label>
                  <p class="text-muted-ss">ข้อมูลเกี่ยวกับการชำระเงินจะถูกเก็บรักษาภายใต้ความปลอดภัยของระบบ</p>
                </div>
              </div>
              <button class="btn btn--purple ma-0 btn-confirm" v-if="!isPaypal" @click="submit()" :disabled="!acceptPolicy">ยืนยันการบริจาค</button>
              <paypal-button ref="paypalButton2"
                             v-if="isPaypal"
                             v-show="paypalButtonReady"
                             id="paypal-button2"
                             :payment="paypalPayment"
                             :onAuthorize="paypalOnAuthorize"
                             :onCancel="paypalOnCancel"
                             v-on:ready="paypalButtonReady = true"></paypal-button>
              <loader v-if="isPaypal" v-show="!paypalButtonReady"></loader>

              <div class="text-muted text-center pd-15 mt-15" v-if="isTransfer">หลังจากโอนเงินแล้ว กรุณายืนยันการโอนเงินจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</div>
            </div>
            <!--<div class="block block-primary shadow">
              <div class="summary__row fs-sm">
                <span>หากลูกค้าท่านใดที่ยังไม่ได้รับอีเมลการสั่งซื้อสินค้าภายใน 30 นาที ขอรบกวนลูกค้าส่งหมายเลขคำสั่งซื้อมายังอีเมล <a :href="'mailto:'+$config.WEBSITE_EMAIL">{{ $config.WEBSITE_EMAIL }}</a> นี้ด้วยค่ะ ทางเราจะดำเนินการตรวจสอบข้อมูลและแจ้งผลกลับไป ขอบคุณค่ะ</span>
              </div>
            </div>-->
          </div>

          <div class="sidebar sidebar-ghost"></div>
        </div>
      </div>
    </div>

    <div class="container block-primary block shadow radius empty-cart" v-if="$utils.isCartEmpty()">
      คุณยังไม่ได้เลือกรายการบริจาค
      <router-link :to="{ name: 'products_list' }">เลือกดูรายการของเรา</router-link>
    </div>

    <form ref="form2c2p" :action="form2c2p.paymentUrl" method="POST">
      <input type="hidden" name="version" :value="form2c2p.version">
      <input type="hidden" name="merchant_id" :value="form2c2p.merchant_id">
      <input type="hidden" name="payment_description" :value="form2c2p.payment_description">
      <input type="hidden" name="order_id" :value="form2c2p.order_id">
      <!--<input type="hidden" name="invoice_no" :value="form2c2p.payment_description">-->
      <input type="hidden" name="currency" :value="form2c2p.currency">
      <input type="hidden" name="amount" :value="form2c2p.amount">
      <input type="hidden" name="result_url_1" :value="form2c2p.resultUrl">
      <input type="hidden" name="result_url_2" :value="form2c2p.backendReturnUrl">
      <input type="hidden" name="payment_option" :value="form2c2p.paymentOption">
      <input type="hidden" name="customer_email" :value="email">
      <input type="hidden" name="payment_expiry" :value="form2c2p.paymentExpiry">
      <input type="hidden" name="default_lang" value="th">
      <div v-if="form2c2p.recurring == 'Y' || form2c2p.recurring == 'M'">
        <input type="hidden" name="recurring" :value="form2c2p.recurring">
        <input type="hidden" name="charge_on_date" :value="form2c2p.chargeOnDate" v-if="form2c2p.chargeOnDate != ''">
        <input type="hidden" name="charge_next_date" :value="form2c2p.chargeNextDate" v-if="form2c2p.chargeNextDate != ''">
        <input type="hidden" name="allow_accumulate" :value="form2c2p.allowAccumulate">
        <input type="hidden" name="max_accumulate_amount" :value="form2c2p.maxAccumulateAmount" v-if="form2c2p.allowAccumulate == 'Y'">
        <input type="hidden" name="order_prefix" :value="form2c2p.orderPrefix">
        <input type="hidden" name="recurring_amount" :value="form2c2p.recurringAmount">
        <input type="hidden" name="recurring_count" :value="form2c2p.recurringCount">
        <input type="hidden" name="recurring_interval" :value="form2c2p.recurringInterval || 0" v-if="form2c2p.recurringInterval > 0">
        <input type="hidden" name="user_defined_1" :value="form2c2p.userDefined1 || ''">
      </div>
      <input type="hidden" name="hash_value" :value="form2c2p.hash_value">
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import paypal from 'paypal-checkout'
import PaymentSummary from './PaymentSummary.vue'
import CartSummary from './CartSummary.vue'
import PaypalButton from './PaypalButton.vue'
import Loader from './Loader.vue'
import AddressForm from './AddressForm.vue'
import { INVOICE_STATUSES, INVOICE_SUBSTATUSES } from '../utils'
require('../omise')

import VueMask from 'v-mask'
Vue.use(VueMask)

const ALLOWED_METHOD = ['credit_card', 'bank_transfer', 'paypal']

export default {
  components: {
    AddressForm,
    Loader,
    PaypalButton,
    PaymentSummary,
    CartSummary
  },
  name: 'Payment',
  created () {
    window.Omise.setPublicKey(Vue.config.OMISE_KEY)

    this.$store.dispatch('initCheckoutInfo')
    this.$store.dispatch('initDonateType')

    const dependIsShippingRequired = {
      field: 'isShippingRequired',
      value: true
    }

    this.$v = this.$validator.init(this, {
      email: { checkEmpty: true, checkEmail: true, checkFacebookEmail: true },
      phone: { checkEmpty: true, checkPhone: true },
      // firstName: { checkEmpty: true, dependOn: depenOnNeedReceipt },
      // lastName: { checkEmpty: true, dependOn: depenOnNeedReceipt },
      fullname: { checkEmpty: true, dependOn: dependIsShippingRequired },
      shippingAddress: { checkEmpty: true, dependOn: dependIsShippingRequired },
      shippingProvince: { checkEmpty: true, dependOn: dependIsShippingRequired },
      shippingPostCode: { checkEmpty: true, dependOn: dependIsShippingRequired },
      receiptFullname: { checkEmpty: true },
      taxId: { checkEmpty: true, checkTaxId: true, checkTaxIdFormat: true },
      paymentMethod: { checkEmpty: true, checkAllowedValues: ALLOWED_METHOD },
      internetBankingOffsite: { checkEmpty: true, dependOn: { field: 'paymentMethod', value: 'internet_banking' } }
    })

    this.$utils.fbTrack('INITIATED_CHECKOUT', this.grandTotalPrice, {
      CONTENT_TYPE: 'product',
      NUM_ITEMS: this.totalItems,
      CURRENCY: 'THB'
    })
  },
  data () {
    return {
      submitting: false,
      formReady: false,
      showEmailForm: false,
      showAddressForm: false,
      acceptPolicy: false,
      email: '',
      firstName: '',
      lastName: '',
      fullname: '',
      taxId: '',
      telNo: '',
      phone: '',
      shippingAddress: '',
      shippingProvince: '',
      shippingPostCode: '',
      hasReward: false,
      receiptFullname: '',
      receiptAddress: '',
      receiptProvince: '',
      receiptPostalCode: '',
      needReceipt: true,
      needReceiptShipping: false,
      confirmThaiEmail: false,
      paymentMethod: '',
      ccNumber: '',
      ccHolderName: '',
      ccExpired: '',
      ccCVV: '',
      internetBankingOffsite: '',
      omiseToken: '',
      paypalButtonReady: false,
      paypalResolve: null,
      paypalReject: null,
      formValid: false,
      $v: null,
      form2c2p: {},
      invoiceSubmissionPromise: null
    }
  },
  mounted () {
    // prevent chrome autofill
    this.email = this.$utils.cleanEmailInvisibleChars(this.shippingEmail)
    if (this.email.match(/tel.(\d+)@tcfe.or.th/g)) {
      this.email = ''
    }
    if (this.$store.state.user) {
      this.phone = this.$store.state.user.telNo
      this.firstName = this.$store.state.user.firstName
      this.lastName = this.$store.state.user.lastName
      const fullnames = []
      if (this.firstName) {
        fullnames.push(this.firstName)
      }
      if (this.lastName) {
        fullnames.push(this.lastName)
      }
      this.fullname = fullnames.join(' ')
    }

    this.$store.dispatch('initCheckoutInfo')
    const info = this.$store.state.checkoutInfo
    if (info) {
      if (info.email) {
        this.email = info.email
      }
      if (info.phone) {
        this.phone = info.phone
      }
      if (info.firstName) {
        this.firstName = info.firstName
      }
      if (info.lastName) {
        this.lastName = info.lastName
      }
      if (info.fullname) {
        this.fullname = info.fullname
      }
      if (info.taxId) {
        this.taxId = info.taxId
      }
      if (info.needReceiptShipping) {
        this.needReceiptShipping = info.needReceiptShipping
      }
      if (info.receiptAddress) {
        this.receiptAddress = info.receiptAddress
      }
      if (info.receiptProvince) {
        this.receiptProvince = info.receiptProvince
      }
      if (info.receiptPostalCode) {
        this.receiptPostalCode = info.receiptPostalCode
      }
      if (info.receiptFullname) {
        this.receiptFullname = info.receiptFullname
      }
    }
    if (this.$store.state.cart) {
      const p = this.$store.state.cart[0].attributes
      if (p && p.info.rewardProduct) {
        this.hasReward = true
      }
    }

    setTimeout(() => {
      this.formReady = true
    }, 500)

    if (!this.$store.state.user) {
      this.editEmail()
    }
  },
  computed: {
    isShippingRequired () {
      return this.$store.state.cart.some(item =>
        item.attributes &&
        item.attributes.info &&
        item.attributes.info.shippingRequired !== false &&
        this.hasReward
      )
    },
    shippingEmail () {
      if (this.$store.state.user) {
        return this.$store.state.user.shippingContact.email || this.$store.state.user.email
      } else {
        return ''
      }
    },
    isFacebookEmail () {
      return this.email.match(/@facebook.com$/)
    },
    isEmptyAddress () {
      return this.$utils.isEmptyAddress()
    },
    emailFormVisible () {
      this.showEmailForm = this.showEmailForm || this.isFacebookEmail
      return this.showEmailForm || !this.email
    },
    addressFormVisible () {
      return this.isEmptyAddress || this.showAddressForm
    },
    address () {
      return `${this.info.address || ''}`
    },
    city () {
      return `${this.$utils.provincesMap[this.info.province] || ''} ${this.info.postalCode || ''}`
    },
    province () {
      return this.info.province || ''
    },
    postcode () {
      return this.info.postalCode || ''
    },
    fullAddress () {
      let items = []
      if (this.address) {
        items.push(this.address)
      }
      if (this.city) {
        items.push(this.city)
      }
      return items.join(' ')
    },
    receiptCity () {
      return `${this.$utils.provincesMap[this.receiptProvince] || ''} ${this.receiptPostalCode || ''}`
    },
    fullReceiptAddress () {
      let items = []
      if (this.receiptAddress) {
        items.push(this.receiptAddress)
      }
      if (this.receiptCity) {
        items.push(this.receiptCity)
      }
      return items.join(' ')
    },
    useCreditCard () {
      return this._useCreditCard()
    },
    user () {
      return this.$store.state.user
    },
    token () {
      return this.$store.state.token
    },
    info () {
      return this.$store.state.checkoutInfo
    },
    isCreditCard () {
      return this.paymentMethod === 'credit_card'
    },
    isInternetBanking () {
      return this.paymentMethod === 'internet_banking'
    },
    is2C2P123 () {
      return this.paymentMethod === '2c2p:123'
    },
    isLinePay () {
      return this.paymentMethod === 'line_pay'
    },
    isPaypal () {
      return this.paymentMethod === 'paypal'
    },
    isTransfer () {
      return this.paymentMethod === 'bank_transfer'
    },
    defaultPaymentPayload () {
      let offlineShippingDetail = this.$utils.getOfflineShippingInfo() + ' ' + this.$utils.getOfflineShippingDetail()
      offlineShippingDetail = offlineShippingDetail.trim()
      let data = {
        client_id: this.$store.state.clientId,
        domain: this.$config.DOMAIN,
        email: this.email,
        fullname: this.fullname,
        address: this.shippingAddress,
        province: this.shippingProvince,
        postcode: this.shippingPostCode,
        phone_number: this.phone,
        request_receipt: this.needReceipt,
        receipt_fullname: this.receiptFullname,
        request_receipt_shipping: this.needReceiptShipping,
        receipt_tax_id: this.taxId.replace(/[^0-9]/g, ''),
        invoice_product_list: this.$store.state.cart.map(item => {
          return {
            product_sku: item.product.sku,
            product_sub_sku: this.$utils.getProductSubSku(item.product, item.attributes),
            product_quantity: item.quantity,
            product_price: item.product.price,
            product_data: JSON.stringify(item.attributes.info || {}),
            ref_obj_type: 'page',
            ref_obj_id: item.attributes.page.id
          }
        }),
        offline_shipping: true,
        offline_shipping_detail: offlineShippingDetail
      }

      return data
    }
  },
  methods: {
    isPaymentMethodEnable (value) {
      if (this.$store.state.donateType === 'monthly') {
        return Vue.config.AVAILABLE_MONTHLY_PAYMENT_METHOD.includes(value)
      } else {
        return Vue.config.AVAILABLE_PAYMENT_METHOD.includes(value)
      }
    },
    _useCreditCard () {
      return this.paymentMethod === 'credit_card'
    },
    editEmail () {
      this.showEmailForm = true
    },
    editAddress () {
      this.showAddressForm = true
    },
    hasThaiCharacters (value) {
      return value.match(/[\u0e01-\u0e5b]/)
    },
    addressSaved () {
      // TODO: do somethings?
    },
    closeModal () {
      this.$modal.hide()
    },
    showProgressModal (orderId) {
      let text = `กำลังดำเนินการ โปรดอย่าปิดหน้านี้จนกว่าจะทำการชำระเงินสำเร็จ`
      if (orderId) {
        text += ` <br>หมายเลขรายการ: <em>${orderId}</em>`
      }
      this.$modal.show({
        title: 'โปรดรอสักครู่',
        text: text,
        okButton: false,
        showLoader: true
      })
    },
    showErrorModal (message, ok, cancel) {
      let htmlMsg = ''
      if (message) {
        htmlMsg = ` <div class="payment-error-message mt-30"><strong>ข้อความจากระบบ:</strong><div class="-msg">${message}</div></div>`
      }

      const orderId = this.$store.state.orderId
      let orderMsg = ''
      if (orderId) {
        orderMsg = `หมายเลขรายการ: <em>${orderId}</em><br>`
      }

      this.$modal.show({
        title: 'ผิดพลาด',
        text: `${orderMsg}ไม่สามารถชำระเงินได้ กรุณาลองใหม่อีกครั้ง${htmlMsg}`,
        ok: ok,
        cancel: cancel
      })
      this.$utils.fbTrack('paymentError', this.totalPrice, { orderId: orderId, cart: this.$store.state.cart })
    },
    getOmiseToken (cardObject) {
      return new Promise((resolve, reject) => {
        window.Omise.createToken('card', cardObject, (statusCode, response) => {
          if (statusCode === 200) {
            resolve(response.id)
          } else {
            reject(response)
          }
        })
      })
    },
    donePayment (orderId) {
      this.submitting = false
      if (!orderId) {
        orderId = this.$store.state.orderId
      }
      this.closeModal()
      this.$store.dispatch('clearCart').then(() => {
        this.$store.dispatch('clearSelectedPage')
      })
      if (['bank_transfer', 'cheque'].indexOf(this.paymentMethod) > -1) {
        this.$router.push(`/thank-you/${orderId}`)
      } else {
        this.$router.push('thank-you')
      }
      this.$utils.fbTrack('donePayment', this.totalPrice, { orderId: orderId, cart: this.$store.state.cart })
      this.$utils.fbTrackPurchase(this.grandTotalPrice, this.totalItems)
    },
    handlePaymentResult (event) {
      const data = JSON.parse(event.data)
      console.log('handlePaymentResult', data)

      if (data.type === 'userFeedback') {
        this.$store.state.ws.removeEventListener('message', this.handlePaymentResult)
        this.submitting = false

        const payload = data.payload
        this.invoiceSubmissionPromise.then(() => {
          if (payload.type === 'PaymentResult' && payload.order_id === this.$store.state.orderId) {
            if (payload.success === true) {
              switch (payload.payment_method) {
                case 'internet_banking':
                  this.handlePaymentResultInternetBanking(payload)
                  break
                case 'line_pay':
                  this.handlePaymentResultLinePay(payload)
                  break
                default:
                  // backward compatibility
                  this.handlePaymentResultInternetBanking(payload)
              }
            } else {
              this.showErrorModal(payload.message)
              this.$store.dispatch('resetPayment')
            }

            this.submitting = false
          }
        })
      }
    },
    handlePaymentResultInternetBankingOmise (payload) {
      if (payload.data && payload.data.authorize_uri) {
        window.location.href = payload.data.authorize_uri
      } else if (payload.data && payload.data.status === 'successful') {
        this.donePayment()
      } else {
        this.showErrorModal(payload.message)
        this.$store.dispatch('resetPayment')
      }
    },
    handlePaymentResultInternetBanking2c2p (payload) {
      // TODO: noomz here
    },
    handlePaymentResultInternetBanking (payload) {
      if (payload.payment_provider === 'omise') {
        this.handlePaymentResultInternetBankingOmise(payload)
      } else if (payload.payment_provider === '2c2p') {
        this.handlePaymentResultInternetBanking2c2p(payload)
      } else {
        // backward compatibility
        this.handlePaymentResultInternetBankingOmise(payload)
      }
    },
    handlePaymentResultLinePay (payload) {
      console.log('payload.data', payload.data)
      if (payload.data && payload.data.info && payload.data.info.paymentUrl && payload.data.info.paymentUrl.web) {
        window.location.href = payload.data.info.paymentUrl.web
      } else if (payload.data && payload.data.status === 'successful') {
        // TODO: handle
        this.donePayment()
      } else {
        this.showErrorModal(payload.message)
        this.$store.dispatch('resetPayment')
      }
    },
    charge (extraPayload) {
      this.$store.state.ws.addEventListener('message', this.handlePaymentResult)

      let resolver = null
      this.invoiceSubmissionPromise = new Promise((resolve) => {
        resolver = resolve
      })

      let payload = this.defaultPaymentPayload

      Object.assign(payload, extraPayload)

      let url = 'invoices'
      if (this.$store.state.donateType === 'monthly') {
        url += '?donateType=monthly&planCode=' + Vue.config.DEFAULT_PLAN_CODE
      }

      this.$http.post(url, payload)
        .then(resp => {
          this.$store.dispatch('setOrderId', resp.body.order_id).then(() => {
            this.showProgressModal(this.$store.state.orderId)
            resolver()
          })
          this.submitting = false

          // fallback when timeout on reply from omise + pubsub
          const t = setInterval(() => {
            if (this.$store.state.orderId && (new Date()) - this.$store.state.orderIdTimestamp > Vue.config.PAYMENT_TIMEOUT) {
              // cancel handleOmisePaymentResult
              this.$store.state.ws.removeEventListener('message', this.handlePaymentResult)

              // get order status
              this.$utils.getInvoice(this.$store.state.orderId)
                .then(invoice => {
                  if (invoice.status === INVOICE_STATUSES.PAID) {
                    clearInterval(t)
                    this.donePayment()
                    return
                  }

                  if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                    clearInterval(t)
                    this.$store.dispatch('resetPayment')
                    this.showErrorModal()
                  }
                })
                .catch(err => {
                  console.log(err)
                })
            }
          }, Vue.config.PAYMENT_RECHECK_INTERVAL)
        })
        .catch(err => {
          console.log(err)
          resolver()
          if (err.body.invalidItems) {
            this.showErrorModal(this.getStockInvalidItemsMessages(err.body.invalidItems), () => {
              this.$utils.scrollToFirstErrors()
            })
          } else if (err.body.message.match(/invalid/i)) {
            this.showErrorModal(err.body.message, () => {
              this.$utils.scrollToFirstErrors()
            })
          } else {
            this.showErrorModal()
          }
          this.$store.dispatch('resetPayment')
          this.submitting = false
        })
    },
    payByOmiseCreditCard () {
      const cardObject = {
        name: this.ccHolderName,
        number: this.ccNumber,
        expiration_month: this.ccExpired.split('/')[0],
        expiration_year: this.ccExpired.split('/')[1],
        security_code: this.ccCVV
      }

      this.getOmiseToken(cardObject)
        .then(token => {
          this.charge({
            payment_method: 'credit_card',
            payment_payload: token
          })
        })
        .catch(err => {
          console.log(err)
          this.$store.dispatch('setOrderId', null)
          this.showErrorModal(err.message)
          this.submitting = false
        })
    },
    payByOmiseInternetBanking () {
      this.charge({
        payment_method: 'internet_banking',
        payment_payload: this.internetBankingOffsite + '|' + window.location.href
      })
    },
    payBy2c2pInternetBanking () {
      this.payBy2c2p({
        payment_method: '2c2p:123',
        payment_payload: JSON.stringify({
          returnUrl: this.returnUrlFor2c2p()
        })
      })
    },
    returnUrlFor2c2p () {
      return Vue.http.options.root + 'postback/2c2p'
      // return window.location.href
    },
    handle2c2pPaymentResult (event) {
      const data = JSON.parse(event.data)
      console.log('handle2c2pPaymentResult', data)
      if (data.type === 'userFeedback') {
        this.$store.state.ws.removeEventListener('message', this.handle2c2pPaymentResult)
        this.submitting = false

        const payload = data.payload
        this.invoiceSubmissionPromise.then(() => {
          if (payload.type === 'PaymentResult' && payload.order_id === this.$store.state.orderId) {
            if (payload.success === true) {
              let d = payload.data
              this.form2c2p = {
                version: d.version,
                merchant_id: d.merchantId,
                currency: 764,
                hash_value: d.hashValue,
                payment_description: this.$store.state.orderId,
                order_id: d.shortOrderId,
                amount: d.amount,
                paymentOption: d.paymentOption,
                resultUrl: this.returnUrlFor2c2p(),
                backendReturnUrl: d.backendReturnUrl,
                paymentUrl: d.paymentUrl,
                paymentExpiry: d.paymentExpiry,
                orderPrefix: d.orderPrefix,
                allowAccumulate: d.allowAccumulate,
                maxAccumulateAmount: d.maxAccumulateAmount,
                recurring: d.recurring,
                recurringAmount: d.recurringAmount,
                recurringInterval: d.recurringInterval,
                recurringCount: d.recurringCount || 0,
                chargeNextDate: (d.chargeNextDate || '').trim(),
                chargeOnDate: (d.chargeOnDate || '').trim(),
                userDefined1: d.userDefined1,
                userDefined2: d.userDefined2,
                userDefined3: d.userDefined3,
                userDefined4: d.userDefined4,
                userDefined5: d.userDefined5
              }

              this.$forceUpdate()
              setTimeout(() => {
                this.$refs.form2c2p.submit()
              }, 2000)
            } else {
              this.showErrorModal(payload.message)
              this.$store.dispatch('resetPayment')
            }

            this.submitting = false
          }
        })
      }
    },
    payBy2c2pCreditCard () {
      this.payBy2c2p({
        payment_method: 'credit_card',
        payment_payload: JSON.stringify({
          returnUrl: this.returnUrlFor2c2p()
        })
      })
    },
    payBy2c2p (extraPayload) {
      let payload = this.defaultPaymentPayload
      Object.assign(payload, extraPayload)

      this.$store.state.ws.addEventListener('message', this.handle2c2pPaymentResult)

      let resolver = null
      this.invoiceSubmissionPromise = new Promise((resolve) => {
        resolver = resolve
      })

      let url = 'invoices'
      if (this.$store.state.donateType === 'monthly') {
        url += '?donateType=monthly&planCode=' + Vue.config.DEFAULT_PLAN_CODE
      }

      this.$http.post(url, payload)
        .then(resp => {
          this.$store.dispatch('setOrderId', resp.body.order_id).then(() => {
            this.showProgressModal(this.$store.state.orderId)
            resolver()
          })
          this.submitting = false

          // fallback when timeout on reply from omise + pubsub
          const t = setInterval(() => {
            if (this.$store.state.orderId && (new Date()) - this.$store.state.orderIdTimestamp > Vue.config.PAYMENT_TIMEOUT) {
              this.$store.state.ws.removeEventListener('message', this.handle2c2pPaymentResult)

              // get order status
              this.$utils.getInvoice(this.$store.state.orderId)
                .then(invoice => {
                  if (invoice.status === INVOICE_STATUSES.PAID) {
                    clearInterval(t)
                    this.donePayment()
                    return
                  }

                  if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                    clearInterval(t)
                    this.$store.dispatch('resetPayment')
                    this.showErrorModal()
                  }
                })
                .catch(err => {
                  console.log(err)
                })
            }
          }, Vue.config.PAYMENT_RECHECK_INTERVAL)
        })
        .catch(e => {
          console.log(e)
          resolver()
          this.showErrorModal()
          this.$store.dispatch('resetPayment')
          this.submitting = false
        })
    },
    payByTransfer () {
      let payload = this.defaultPaymentPayload
      payload.payment_method = 'bank_transfer'

      this.$http.post('invoices', payload)
        .then(resp => {
          this.$store.dispatch('setOrderId', resp.body.order_id)
          this.submitting = false
          this.donePayment()
        })
        .catch(err => {
          console.log(err)
          if (err.body.invalidItems) {
            this.showErrorModal(this.getStockInvalidItemsMessages(err.body.invalidItems), () => {
              this.$utils.scrollToFirstErrors()
            })
          } else if (err.body.message.match(/invalid/i)) {
            this.showErrorModal(err.body.message, () => {
              this.$utils.scrollToFirstErrors()
            })
          } else {
            this.showErrorModal()
          }
          this.submitting = false
        })
    },
    payByCheque () {
      let payload = this.defaultPaymentPayload
      payload.payment_method = 'cheque'

      this.$http.post('invoices', payload)
        .then(resp => {
          this.$store.dispatch('setOrderId', resp.body.order_id).then(() => {
            this.submitting = false
            this.donePayment(resp.body.order_id)
          })
        })
        .catch(err => {
          console.log(err)
          if (err.body.invalidItems) {
            this.showErrorModal(this.getStockInvalidItemsMessages(err.body.invalidItems), () => {
              this.$utils.scrollToFirstErrors()
            })
          } else if (err.body.message.match(/invalid/i)) {
            this.showErrorModal(err.body.message, () => {
              this.$utils.scrollToFirstErrors()
            })
          } else {
            this.showErrorModal()
          }
          this.submitting = false
        })
    },
    payByPaypal () {
      // Nothing.
    },
    payByLinePay () {
      this.charge({
        payment_method: 'line_pay',
        payment_payload: 'request|' + window.location.href
      })
    },
    getStockInvalidItemsMessages (invalidItems) {
      if (!invalidItems) {
        return ''
      }

      let productsMap = {}
      for (let item of this.$store.state.cart) {
        productsMap[item.product.sku] = item.product.name
      }

      let itemMessages = []
      for (let item of invalidItems) {
        let skuParts = item.sku.split(':')
        itemMessages.push(`- ${productsMap[skuParts[0]]} (${skuParts[1].replace(/_/g, ' / ')})`)
      }
      return `มีจำนวนรายการคงคลังไม่เพียงพอสำหรับรายการต่อไปนี้<br>${itemMessages.join('<br>')}`
    },
    handlePaypalCreatePaymentResult (event) {
      const data = JSON.parse(event.data)

      if (data.type === 'userFeedback') {
        this.$store.state.ws.removeEventListener('message', this.handlePaypalCreatePaymentResult)
        const payload = data.payload
        if (payload.type === 'PaymentResult' && payload.order_id === this.$store.state.orderId) {
          if (payload.data && payload.data.state === 'created' && payload.success) {
            this.paypalResolve(payload.data.id)
          } else {
            this.submitting = false
            this.showErrorModal()
            this.paypalReject(new Error('Cannot create payment'))
          }
        }
      }
    },
    handlePaypalExecutePaymentResult (event) {
      const data = JSON.parse(event.data)

      if (data.type === 'userFeedback') {
        this.$store.state.ws.removeEventListener('message', this.handlePaypalExecutePaymentResult)
        const payload = data.payload
        if (payload.type === 'PaymentResult' && payload.order_id === this.$store.state.orderId) {
          if (payload.data && payload.data.state === 'approved' && payload.success) {
            this.paypalResolve()
            this.donePayment()
          } else {
            this.submitting = false
            this.showErrorModal()
            this.paypalReject(new Error('Cannot execute payment'))
          }
        }
      }
    },
    paypalPayment (data, actions) {
      // trigger for submit.
      if (!this.submit()) {
        return Promise.reject(new Error('Form is not validated'))
      }

      let payload = this.defaultPaymentPayload
      payload.payment_method = 'paypal'

      this.$store.state.ws.removeEventListener('message', this.handlePaypalExecutePaymentResult)
      this.$store.state.ws.addEventListener('message', this.handlePaypalCreatePaymentResult)

      return new paypal.Promise((resolve, reject) => {
        this.paypalResolve = resolve
        this.paypalReject = reject

        this.$http.post('invoices', payload)
          .then(resp => {
            console.log(resp)
            this.$store.dispatch('setOrderId', resp.body.order_id).then(() => {
              this.showProgressModal(this.$store.state.orderId)
            })
          })
          .catch(err => {
            console.log(err)
            this.submitting = false
            if (err.body.invalidItems) {
              this.showErrorModal(this.getStockInvalidItemsMessages(err.body.invalidItems), () => {
                this.$utils.scrollToFirstErrors()
              })
            } else if (err.body.message.match(/invalid/i)) {
              this.showErrorModal(err.body.message, () => {
                this.$utils.scrollToFirstErrors()
              })
            } else {
              this.showErrorModal()
            }
            reject(err)
          })
      })
    },
    paypalOnAuthorize (data, actions) {
      data = {
        client_id: this.$store.state.clientId,
        payment_id: data.paymentID,
        payer_id: data.payerID,
        order_id: this.$store.state.orderId
      }

      return new Promise((resolve, reject) => {
        this.paypalResolve = resolve
        this.paypalReject = reject

        this.$store.state.ws.removeEventListener('message', this.handlePaypalCreatePaymentResult)
        this.$store.state.ws.addEventListener('message', this.handlePaypalExecutePaymentResult)
        this.$store.dispatch('setPaypalPaymentId', data.payment_id)

        this.$http.post('payments/paypal/execute', data)
          .then(resp => {
            console.log(resp)

            // fallback when timeout on reply from paypal + pubsub
            const t = setInterval(() => {
              if (this.$store.state.orderId && (new Date()) - this.$store.state.orderIdTimestamp > Vue.config.PAYMENT_TIMEOUT) {
                // cancel handleOmisePaymentResult
                this.$store.state.ws.removeEventListener('message', this.handlePaypalExecutePaymentResult)

                // get order status
                this.$utils.getInvoice(this.$store.state.orderId)
                  .then(invoice => {
                    if (invoice.status === INVOICE_STATUSES.PAID) {
                      clearInterval(t)
                      this.donePayment()
                      return
                    }

                    if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                      clearInterval(t)
                      this.showErrorModal()
                    }
                  })
                  .catch(err => {
                    console.log(err)
                  })
              }
            }, Vue.config.PAYMENT_RECHECK_INTERVAL)
          })
          .catch(err => {
            console.log(err)
            this.showErrorModal()
            this.paymentMethod = ''
            setTimeout(() => {
              this.paymentMethod = 'paypal'
            }, 500)
            reject(err)
          })
      })
    },
    paypalOnCancel (data, actions) {
      this.submitting = false
      this.$store.state.ws.removeEventListener('message', this.handlePaypalCreatePaymentResult)
      this.$store.state.ws.removeEventListener('message', this.handlePaypalExecutePaymentResult)
      this.$store.dispatch('resetPayment')
      this.$modal.hide()
    },
    isControlKey (key) {
      return 'Backspace,Tab,Enter,Meta,ArrowLeft,Left,ArrowRight,Right'.split(',').indexOf(key) !== -1
    },
    getEventKey (event) {
      return this.$utils.getEventKey(event)
    },
    validateCreditCardHolderKey (event) {
      let allowedKeys = 'Backspace,Tab,Enter,Meta'.split(',')
      let eventKey = this.getEventKey(event)

      if (!eventKey || event.metaKey) {
        return
      }

      if (allowedKeys.indexOf(eventKey) === -1 && !this.isControlKey(eventKey) && !eventKey.match(/[ a-zA-Z.]/)) {
        event.preventDefault()
        return
      }
    },
    updateCreditCardHolder (event) {
      window.requestAnimationFrame(() => {
        this.ccHolderName = event.target.value.replace(/[^ a-zA-Z.]/g, '')
      })
    },
    validateCreditCardKey (event) {
      let allowedKeys = '0,1,2,3,4,5,6,7,8,9,Backspace,Tab,Enter,Meta,ArrowLeft,Left,ArrowRight,Right'.split(',')
      let eventKey = this.getEventKey(event)

      if (event.metaKey) {
        return
      }

      if (allowedKeys.indexOf(eventKey) === -1) {
        event.preventDefault()
        return
      }
      if (!this.isControlKey(eventKey) && this.ccNumber.replace(/\s+/g, '').length >= 16) {
        event.preventDefault()
        return
      }
    },
    updateCreditCardValue (event) {
      const originalValue = event.target.value.replace(/\s+/g, '')
      let value = originalValue.split('')
      let chunks = []
      chunks.push(value.splice(0, 4).join(''))
      if (value.length) chunks.push(value.splice(0, 4).join(''))
      if (value.length) chunks.push(value.splice(0, 4).join(''))
      if (value.length) chunks.push(value.splice(0, 4).join(''))

      window.requestAnimationFrame(() => {
        this.ccNumber = chunks.join(' ').trim().replace(/[^0-9 ]/g, '')
      })
    },
    validateExpiredKey (event) {
      let allowedKeys = '0,1,2,3,4,5,6,7,8,9,Backspace,Tab,Enter,ArrowLeft,Left,ArrowRight,Right'.split(',')
      let eventKey = this.getEventKey(event)

      if (!eventKey || event.metaKey) {
        return
      }

      if (allowedKeys.indexOf(eventKey) === -1) {
        event.preventDefault()
        return
      }

      if (!this.isControlKey(eventKey) && this.ccExpired.length >= 5) {
        event.preventDefault()
        return
      }

      if (this.ccExpired[this.ccExpired.length - 1] === '/' && eventKey === 'Backspace') {
        this.ccExpired = this.ccExpired.replace(/\/$/, '')
      }
    },
    updateExpiredValue (value) {
      if (value.match(/^[0-9]{0,2}\/[0-9]{0,2}$/)) {
        return
      }
      window.requestAnimationFrame(() => {
        this.ccExpired = value.replace(/[^0-9]/g, '').replace(/^([0-9]{2})\/?/, '$1/').slice(0, 5)
      })
    },
    validateCVVKey (event) {
      let allowedKeys = '0,1,2,3,4,5,6,7,8,9,Backspace,Tab,Enter'.split(',')
      let eventKey = this.getEventKey(event)

      if (event.metaKey) {
        return
      }

      if (allowedKeys.indexOf(eventKey) === -1) {
        event.preventDefault()
        return
      }

      if (!this.isControlKey(eventKey) && this.ccCVV.length >= 4) {
        event.preventDefault()
        return
      }
    },
    saveProfile () {
      const user = this.$store.state.user
      const payload = {
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        telNo: user.telNo,
        address: {
          address: this.address,
          province: this.province,
          postcode: this.postcode
        },
        shippingContact: {
          email: this.email,
          firstName: this.info.firstName,
          lastName: this.info.lastName,
          telNo: this.info.phone
        }
      }

      this.$http.post('members/profile', payload)
        .catch(err => {
          console.log(err)
        })
    },
    submit ($event) {
      // cleansing e-mail
      this.email = this.$utils.cleanEmailInvisibleChars(this.email)

      if (!this.acceptPolicy) {
        this.$modal.show({
          title: 'การยอมรับข้อตกลงและเงื่อนไข',
          text: 'กรุณาอ่าน ข้อตกลงและเงื่อนไข ก่อนทำการบริจาค หากไม่ยอมรับเราจะไม่สามารถดำเนินการรับการบริจาคได้'
        })
        return
      }

      if (this.totalPrice === 0) {
        this.$modal.show({
          title: 'มีบางอย่างไม่ถูกต้อง',
          text: 'จำนวนรายการไม่สามารถเป็นศูนย์ได้ กรุณาเลือกรายการใหม่หรือเพิ่มจำนวนก่อนทำรายการ'
        })
        return
      }

      if (!this.$v.validate()) {
        this.$forceUpdate()
        this.$utils.scrollToFirstErrors()
        return
      }

      // if (this.emailFormVisible) {
      //   let user = this.$store.state.user || {
      //     shippingContact: {}
      //   }
      //   user.shippingContact.email = this.email
      //   this.$store.dispatch('setUser', user)
      // }

      // check if contain Thai chars
      if (this.hasThaiCharacters(this.email) && !this.confirmThaiEmail) {
        this.$modal.show({
          title: 'แจ้งเตือน',
          text: `อีเมลของคุณมีอักขระไทยปรากฏอยู่ ( <em>${this.email}</em> ) คุณแน่ใจจะใช้อีเมลนี้หรือไม่`,
          cancelButton: true,
          ok: () => {
            this.confirmThaiEmail = true
            this.submit($event)
          }
        })
        return
      }

      const checkoutInfo = {
        email: this.email,
        phone: this.phone,
        needReceipt: this.needReceipt,
        needReceiptShipping: this.needReceiptShipping,
        taxId: this.taxId.replace(/[^0-9]/g, ''),
        fullname: this.fullname,
        receiptFullname: this.receiptFullname,
        receiptAddress: this.receiptAddress,
        receiptProvince: this.receiptProvince,
        receiptPostalCode: this.receiptPostalCode
      }
      this.$store.dispatch('updateCheckoutInfo', checkoutInfo)

      // if (this.addressFormVisible) {
      //   if (!this.$refs.addressForm.validate()) {
      //     this.$forceUpdate()
      //     this.$utils.scrollToFirstErrors()
      //     return
      //   }
      //   this.$refs.addressForm.submit()
      //   if (this.$store.state.user && this.$store.state.user.uuid) {
      //     this.saveProfile()
      //   }
      // }

      if (this.submitting) {
        return
      }
      this.submitting = true
      this.showProgressModal()
      this.$store.dispatch('setPaymentMethod', this.paymentMethod)

      if (this.isPaypal) {
        return true
      }

      switch (this.paymentMethod) {
        case 'credit_card':
          this.payBy2c2pCreditCard()
          break
        case 'internet_banking':
          this.payBy2c2pInternetBanking()
          break
        case 'bank_transfer':
          this.payByTransfer()
          break
        case 'cheque':
          this.payByCheque()
          break
        case 'paypal':
          this.payByPaypal()
          break
        case 'line_pay':
          this.payByLinePay()
          break
        case '2c2p:123':
          this.payBy2c2pInternetBanking()
          break
      }
    }
  }
}

</script>

<style scoped lang="less">
.payment-page.bank_transfer {
  padding-bottom: 152px;
}
button {
  width: 100%;
}
.empty-cart {
  padding: 15px;
}
.txt-normal {
  font-size: 20px;
  font-weight: 300;
}
</style>

<style lang="scss">
#paypal-button2 .paypal-button-container .paypal-button-parent {
  width: 100%;
}
.block__img__wrapper {
  margin-left: 10px;
}
.block__img__wrapper:last-child {

}
.form__label--note {
  display: inline-block;
  margin-left: 25px;
  @media (min-width: 768px) {
  + .block--icon-bank {
      margin-top: -25px;
      width: 30%;
    }
  }
}

@media (max-width: 767px) {
  .promptpay__wrapper {
    flex-wrap: wrap;
    .ic-promptpay { margin-bottom: 10px; }
    .promptpay--detail { padding-left: 0 !important;}
  }
  .block__img__wrapper {
    margin-left: 0;
    margin-right: 10px;
  }
}
  .promptpay__wrapper {
    border-bottom: #dfdfdf solid 1px;
    padding-bottom: 18px;
    .promptpay--detail {
      padding-left: 10px;
    }

  }

  button.btn-confirm:disabled {
    opacity: 0.7;
    &:hover {
      opacity: 0.6;
    }
  }

  .receipt-shipping-info {
    // border: 2px solid #ddd;
    // border-radius: 5px;
    // padding: 16px;
  }
</style>



// WEBPACK FOOTER //
// Payment.vue?1b546c30